/**
 * LiveIcon: small agent-tinted dot with simpliloquy-radio-pulse outer ring.
 * Reads as "this agent is broadcasting" per BRAND.md §Motion. Used in the
 * top bar to give the chrome the V2 instrument-panel register.
 */
export function LiveIcon({ size = 12 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <circle
        cx="8"
        cy="8"
        r="4"
        fill="none"
        stroke="var(--agent-accent)"
        strokeWidth="1.25"
        className="simpliloquy-radio-pulse"
        style={{ transformOrigin: '8px 8px', transformBox: 'fill-box' }}
      />
      <circle cx="8" cy="8" r="2.5" fill="var(--agent-accent)" />
    </svg>
  );
}
